import axios from 'axios';

// Masav (מס"ב) payment-import service. The global axios config (authService.ts) provides the
// baseURL + Authorization header; we send the file as multipart/form-data.

// Mirrors backend MasavRowCategory enum.
export enum MasavRowCategory {
  WillUpdate = 1,
  CustomerNotIdentified = 2,
  NoActivePlan = 3,
  NotUniquelyIdentified = 4,
  MissingRequiredFields = 5,
  InvalidValues = 6,
  NoPendingForMonth = 7,
  DuplicateExact = 8,
  DuplicateDiffering = 9,
  EmptyRow = 10,
  CorruptText = 11,
}

export interface MasavRowResult {
  rowIndex: number;
  customerName?: string;
  payerIdNumber?: string;
  address?: string;
  phone?: string;
  accountDetails?: string;
  amount?: number;
  rawAmount?: string;
  paymentsBalance?: string;
  csvCategory?: string;
  csvNotes?: string;
  category: MasavRowCategory;
  reason?: string;
  clientId?: number;
  matchedClientName?: string;
  paymentPlanId?: number;
  installmentNumber?: number;
  dueDate?: string;
  expectedAmount?: number;
  delta?: number;
  existingAmount?: number;
  existingPaymentId?: number;
}

export interface MasavPreviewResult {
  fileName: string;
  selectedMonth: string;
  detectedEncoding: string;
  totalRows: number;
  rows: MasavRowResult[];
  countsByCategory: Record<string, number>;
  fileError?: string;
}

export interface MasavDuplicateResolution {
  rowIndex: number;
  action: 'Update' | 'Skip';
}

export interface MasavCommitResult {
  savedCount: number;
  updatedCount: number;
  skippedCount: number;
  failedCount: number;
  errors: string[];
}

export const masavApi = {
  // Read-only preview: parse + validate + match.
  preview: async (file: File, month: string): Promise<MasavPreviewResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('month', month);
    const response = await axios.post<MasavPreviewResult>('/masav/preview', formData);
    return response.data;
  },

  // Commit only the valid rows; resolutions decide differing-duplicate rows.
  commit: async (
    file: File,
    month: string,
    resolutions: MasavDuplicateResolution[]
  ): Promise<MasavCommitResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('month', month);
    formData.append('resolutions', JSON.stringify(resolutions));
    const response = await axios.post<MasavCommitResult>('/masav/commit', formData);
    return response.data;
  },
};

export const handleMasavApiError = (error: any): string => {
  if (error?.response?.data?.message) return error.response.data.message;
  if (typeof error?.response?.data === 'string') return error.response.data;
  if (error?.message) return error.message;
  return 'אירעה שגיאה לא צפויה';
};
